import React, { useEffect, useState } from 'react'
import './banner.css'
import { AiFillInfoCircle, AiOutlineClose } from 'react-icons/ai'

function Banner() {
  let [bannerPresent, setBannerPresent] = useState()

  useEffect(() => {
    const currentBannerState = localStorage.getItem('bannerPresent') || '1'
    setBannerPresent(currentBannerState)
  }, [])

  useEffect(() => {
    localStorage.setItem('bannerPresent', bannerPresent)
  }, [bannerPresent])

  let changeBannerPresent = () => {
    setBannerPresent('0')
    localStorage.setItem('bannerPresent', bannerPresent)
  }

  if (bannerPresent === '1') {
    return (
      <div className="banner2">
        <div className="insidebanner">
          <span className="close">
            <AiOutlineClose size={16} onClick={changeBannerPresent} />
          </span>
          <span className="infoandtext">
            <span className="info">
              <AiFillInfoCircle size={16} />
            </span>
            &nbsp;&nbsp; You will start to see some upgrades to the PayPal
            developer experience in the coming months.&nbsp;
            <a className="anchorlink2" href="/docs/about/#whats-new">
              Learn more here.
            </a>
          </span>
        </div>
      </div>
    )
  }
  return null
}

export default Banner
